module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/system-activity/system-activity.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/system-activity/system-activity.component.scss
// module chunks = main